var _defs, _rect, _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelpIconsTouchpadMove(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 41 52.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #202346;\n        stroke-miterlimit: 10;\n        stroke-width: .75px;\n      }\n\n      .cls-2 {\n        fill: #202346;\n      }\n\n      .cls-2, .cls-3, .cls-4 {\n        stroke-width: 0px;\n      }\n\n      .cls-3 {\n        fill: #d3343f;\n      }\n\n      .cls-4 {\n        fill: #fff;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2.67,
    y: 11.94,
    width: 35.66,
    height: 29.04,
    rx: 2,
    ry: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 17.87,
    cy: 25.09,
    r: 3.7
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "10.33 21.87 9.01 21.91 8.73 15.86 14.78 16.15 14.73 17.47 11.08 17.28 15.35 21.55 14.41 22.48 10.15 18.21 10.33 21.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "9.94 29.12 8.62 29.07 8.33 35.13 14.39 34.84 14.34 33.52 10.69 33.71 14.96 29.44 14.02 28.51 9.75 32.77 9.94 29.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "21.63 16.06 21.68 17.38 25.33 17.2 21.06 21.46 21.99 22.4 26.26 18.13 26.08 21.78 27.4 21.83 27.68 15.78 21.63 16.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m16.59,26.06l7.66,7.66-2.97.48c-.67.11-1.21.6-1.38,1.26-.23.91.32,1.84,1.23,2.07l6.25,1.59c2.19.58,4.53.1,6.31-1.3.2-.16.39-.33.57-.51,2.76-2.76,2.76-7.23,0-9.99l-3.2-3.2c-.71-.71-1.6-.73-2.15-.18l-.02.02c-.53.52-.53,1.38,0,1.9l-.92-.92c-.53-.53-1.38-.53-1.9,0l-.02.02s0,0,0,0c-.54.54-.54,1.42,0,1.96l-.88-.88c-.51-.52-1.33-.58-1.9-.13-.04.03-.07.06-.1.09-.54.54-.54,1.42,0,1.96l-4.24-4.24c-.64-.64-1.68-.64-2.33,0-.64.64-.64,1.68,0,2.33Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIconsTouchpadMove);
export default __webpack_public_path__ + "static/media/help_icons_touchpad_move.1a84edd4d46ec226a3ceada4de2ab983.svg";
export { ForwardRef as ReactComponent };